module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-input"
  }, [_c('Multiselect', {
    attrs: {
      "id": "ajax",
      "track-by": "id",
      "label": "desc",
      "placeholder": "Type to search",
      "value": _vm.resultsLocations,
      "options": _vm.results,
      "multiple": true,
      "searchable": true,
      "loading": _vm.isLoading,
      "internal-search": false,
      "clear-on-select": false,
      "close-on-select": false,
      "options-limit": 300,
      "limit": 3,
      "limit-text": _vm.limitText
    },
    on: {
      "search-change": _vm.search,
      "select": _vm.addSelectedLocationId,
      "remove": _vm.removeSelectedLocationId
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No elements found. Consider changing the search query.")])]), _vm._v(" "), _c('div', {
    staticClass: "locations-submit",
    class: [{
      'is-loading': _vm.isLoading
    }],
    attrs: {
      "id": "locations-submit"
    },
    on: {
      "click": _vm.goTo
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71151d74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FilterLocations.vue
// module id = 442
// module chunks = 1